module.exports = "/_next/static/videos/02-video-ddd19f6c4115769a9c8ce2b984b47eb7.mp4";